exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout[data-v-63ff7c5f]{display:flex;align-items:center;justify-content:center;background:#63aef5}.login[data-v-63ff7c5f]{width:300px}.login .q-if[data-v-63ff7c5f]:before,.login[data-v-63ff7c5f] .q-if-label{color:#b1d6fa}.login .q-btn[data-v-63ff7c5f]{background:#fff}.heading[data-v-63ff7c5f]{font-size:32px;font-weight:300;text-align:center;color:#fff}.links[data-v-63ff7c5f]{display:flex;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63ff7c5f","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/LoginView.vue
// module id = wBGN
// module chunks = 0